"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mockedProductWithoutDiscountsResponseDto = exports.mockedProductResponseWithoutCategory = exports.mockedProductResponse = exports.productCreateOrUpdateMockRequest = void 0;
const common_interfaces_1 = require("../../common-interfaces");
const omit_util_1 = require("../../utils/omit.util");
const discount_1 = require("../discount");
const price_1 = require("../price");
const product_category_1 = require("../product-category");
const product_in_detail_1 = require("../product-in-detail");
exports.productCreateOrUpdateMockRequest = {
  categoryId: 1,
  isActive: true,
  isHidden: false,
  name: {
    en: 'FITNESS #MEDUSHKINAFIT EXPANDER SET',
    ru: 'ФИТНЕС НАБОР ЭСПАНДЕРОВ #MEDUSHKINAFIT'
  },
  description: {
    en: 'FITNESS SET OF EXPANDERS',
    ru: 'ФИТНЕС НАБОР ЭСПАНДЕРОВ'
  },
  tags: [],
  photoIds: [1],
  prices: [{
    isBase: true,
    startAt: null,
    endAt: null,
    list: [{
      currency: common_interfaces_1.Currency.euro,
      amount: 50.00
    }, {
      currency: common_interfaces_1.Currency.ruble,
      amount: 4069
    }]
  }, {
    isBase: false,
    startAt: new Date(),
    endAt: new Date(),
    list: [{
      currency: common_interfaces_1.Currency.euro,
      amount: 7.00
    }, {
      currency: common_interfaces_1.Currency.ruble,
      amount: 3180.50
    }]
  }],
  inDetail: {
    type: common_interfaces_1.ProductType.material,
    material: {
      measurement: {
        weight: 0,
        width: 0,
        height: 0,
        depth: 0,
        unit: common_interfaces_1.Unit.cm
      },
      originCountryId: 1,
      brandCountryId: 1,
      optionIds: [],
      colorOptionIds: []
    }
  }
};
exports.mockedProductResponse = {
  id: 1,
  slug: 'hello-world',
  isDeleted: false,
  createdAt: new Date(),
  updatedAt: new Date(),
  photos: [],
  discounts: [discount_1.mockedDiscountWithoutProductsResponseDto],
  isActive: true,
  isHidden: false,
  inDetail: product_in_detail_1.mockedProductInDetailResponse,
  prices: [price_1.mockedPriceResponse],
  category: product_category_1.mockedProductCategoryResponse,
  name: {
    id: 1,
    en: 'hello world',
    ru: 'привет'
  },
  description: {
    id: 2,
    en: 'world',
    ru: 'мир'
  },
  tags: [{
    id: 3,
    en: 'какие-то тэги',
    ru: 'some tags'
  }],
  neId: '5d8a875dc46e0e113b0a5b43'
};
exports.mockedProductResponseWithoutCategory = omit_util_1.omitObject(exports.mockedProductResponse, 'category');
exports.mockedProductWithoutDiscountsResponseDto = omit_util_1.omitObject(exports.mockedProductResponse, 'discounts');